
import { Component, Prop, Vue } from 'vue-property-decorator'
import eventBus from '../../plugins/eventBus'

@Component
export default class SearchWithSuggestionHeader extends Vue {
  title: string = this.$t('cart') as string
  searchString: string = ''

  searchOnKeyUp($event: any) {
    alert(3)
    eventBus.$emit('search:changed-value', this.searchString)
    // if ($event.keyCode === 13) {
    //   if (window.location.pathname.indexOf('index.html') < 0) {
    //     window.location.href = `/index.html?qs=${this.searchString}`
    //   }
    // }
  }

  mounted() {
    eventBus.$on('search:change-value', (qs: string) => {
      this.searchString = qs
    })
  }
}
